import { useEffect, useState } from "react";
import "./AuthPage.css";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

type Props = {
  onLoginSuccess: (token: string) => void;
};

const AuthPage = ({ onLoginSuccess }: Props) => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const initToken = searchParams.get("token");

    if (initToken) {
      handleInitSession(initToken);
    }
  }, [searchParams]);

  const handleInitSession = async (initToken: string) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.post<{ token: string; expiresIn: string }>(
        "/api/auth/init",
        { initToken },
      );

      onLoginSuccess(response.data.token);
    } catch (err) {
      console.error("Auth error:", err);
      setError("Ошибка авторизации. Проверьте, что приложение открыто в Kit.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="auth-form">
        <div className="title">Authorization</div>
        {isLoading && <div className="auth-message">Авторизация...</div>}
        {error && <div className="auth-error">{error}</div>}
        {!isLoading && !error && !searchParams.get("token") && (
          <div className="auth-message">
            Для авторизации откройте приложение через Voximplant Kit
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthPage;
